import { type GoogleAnalyticsEvent } from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const trackEvent = createAction(
  '[Core/Google Analytic] Track Event',
  props<{ event: GoogleAnalyticsEvent }>(),
);
